'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = resource;

var _utils = require('../utils');

var _isError = require('../status/is-error');

var _isError2 = _interopRequireDefault(_isError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resource(root, id) {
    if (!root || !root.resources || !root.resources[id]) return null;

    var _root$resources$id = root.resources[id],
        data = _root$resources$id.data,
        error = _root$resources$id.error,
        state = _root$resources$id.state;

    if ((0, _isError2.default)(state)) return error;

    return (0, _utils.isUndefined)(data) ? state : data;
}